import WithAuth from "../components/hoc/with-auth.tsx";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx/index.tsx";
import { Flex, Text, Box, Skeleton } from "@chakra-ui/react";
import FrequentTradesPage from "../components/pages/frequent-trades-page.tsx";
import CreateTransactionsForm from "../components/pages/create-transactions-form.tsx";
import CreateUserForm from "../components/pages/create-user-form.tsx";
import { useQuery } from "react-query";
import { getAllGroups } from "../services/crm.service.ts";
import _ from "lodash";
import ErrorBoundary from "../components/ErrorBoundary.tsx";
import { useParams } from "react-router-dom";
import EditUserPermissionFrom from "../components/pages/edit-user-permission-form.tsx";

const EditUserPermission = () => {
  const { login } = useParams();

  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Edit User Permission"
          pageDesc="Edit User Permission"
        >
          <ErrorBoundary>
            {login ? <EditUserPermissionFrom login={login} /> : null}
          </ErrorBoundary>
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default EditUserPermission;
